export const navbarHeight = '96px';

export const sidebarMenuComputedHeight = '97px';

export const collapseActionButtonHeight = '64px';
